<section
  class="color-blue control-container"
  [ngStyle]="styles"
  [formGroup]="form"
>
  <label [for]="field.name">
    {{ field.displayName }}
    <span
      *ngIf="required"
      [ngStyle]="{
        color:
          control.hasError('required') && control.touched ? 'red' : 'initial'
      }"
      >*</span
    >
  </label>
  <mat-form-field appearance="outline" color="primary" fxFlex="grow">
    <mat-select
      [formControlName]="field.name"
      [attr.name]="field.name"
      [attr.data-cy]="field.name"
    >
      <mat-option
        *ngFor="let option of field.options | async"
        [value]="option[field.valueField]"
      >
        {{ option[field.displayField] }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <section *ngFor="let error of errors">
    <mat-error
      [@fadeInOut]
      *ngIf="showErrors && control.hasError(error.name) && control.touched"
      >{{ error.message }}</mat-error
    >
  </section>
</section>
